<template>
<div class="chapter">
<div class="inner_page">
<img src="97813984877273.html.jpg" style="margin-left: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97813984877273.vue?76517b43